<template>
  <div>
    <DepartmentLiquidation
      :title="'CHAPEL FUND'"
    />
  </div>
</template>
<script>
  import DepartmentLiquidation
    from '@/views/input_interface/monthly_liquidation/FundLiquidation'

  export default {
    components: {
      DepartmentLiquidation,
    },
  }
</script>
